import React from "react";
import { Button } from "react-bootstrap";
import { EmptyList } from "../index";

interface EmptyListComponentProps {
    isFilterNotEmpty: boolean;
    buttonName: React.ReactNode;
    emptyFilterTitle: string;
    emptyListTitle: string;
    onClickButton?: () => void;
    isEmployeeRole?: boolean;
    visibilityBtn?: boolean;
    imageSrc?: string;
    altText?: string;
}

const RenderEmptyList: React.FC<EmptyListComponentProps> = ({
    isFilterNotEmpty,
    emptyFilterTitle,
    emptyListTitle,
    buttonName,
    onClickButton,
    isEmployeeRole,
    visibilityBtn,
    imageSrc,
    altText,
}) => {
    return !isFilterNotEmpty ? (
        <EmptyList title={emptyListTitle} imageSrc={imageSrc} altText={altText}>
            <Button
                variant="primary"
                className={`mb-lg-0 px-4 ${isEmployeeRole ? "d-none" : ""}`}
                onClick={onClickButton}
            >
                {buttonName}
            </Button>
        </EmptyList>
    ) : (
        <EmptyList title={emptyFilterTitle}>
            <Button
                variant="primary"
                className={`mb-lg-0 px-4  ${!isEmployeeRole && visibilityBtn ? "d-block" : "d-none"}`}
                onClick={onClickButton}
            >
                {buttonName}
            </Button>
        </EmptyList>
    );
};

export default RenderEmptyList;
